// eslint-disable-next-line
const ar_resource = {
  navbar: {
    home: "بيت",
    dashboard: "لوحة القيادة",
    quotes: "يقتبس",
    document: "وثيقة",
    user: "مستخدم",
    login: "تسجيل الدخول",
    logout: "تسجيل خروج",
    change_password: "تغيير كلمة المرور"
  },
  header: {
    logout_confirmation: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    assigned_roles: "الأدوار المخصصة"
  },
  dashboard: {
    name: "لوحة القيادة",
    title: "مرحبًا بك في لوحة تحكم تخطيط موارد المؤسسات (ERP)",
    subtitle: "قم بتثبيت أو إضافة المزيد من التطبيقات إلى مكتبتك",
  },
  quotes: {
    name: "يقتبس",
    title: "هذه هي لوحة معلومات الأسعار",
    quote_page: "هذه هي صفحة الاقتباسات",
  },
  user: {
    name: "مستخدم",
    title: "هذه هي وحدة المستخدم",
  },
  document: {
    name: "وثيقة",
    title: "هذه هي وحدة الوثيقة",
  },
  manufacturing: {
    name: "التصنيع",
    title: "هذه هي وحدة التصنيع",
    equipments: {
      title: "معدات",
      add_label: "إضافة معدات جديدة",
      edit_label: "تحرير المعدات",
      tableColumns: {
        id_header: "بطاقة تعريف",
        dateTime_header: "التاريخ والوقت",
        unitsConsumed_header: "الوحدات المستهلكة (أ)",
        description_header: "وصف",
        description_placeholder: "أدخل الوصف",
        attachment_header: "مرفق",
        voltageIn_header: "الجهد في (الخامس)",
        startDate_header: "تاريخ البدء",
        endDate_header: "تاريخ الانتهاء",
        workCentre_header: "مركز العمل",
        maintenanceStatus_header: "حالة الصيانة",
        maintenanceStatus_placeholder: "حدد الحالة",
        assignedUser_header: "المستخدم المعين",
        maintenanceCompany_header: "شركة صيانة",
        maintenanceCompany_placeholder: "أدخل شركة الصيانة",
        date_header: "تاريخ",
        date_placeholder: "يوم/شهر/سنة",
      },
      buttons: {
        saveAsDraft_label: "حفظ كمسودة",
        discard_label: "تجاهل",
        save_label: "حفظ",
      },
      tabs: {
        generalDetails: "تفاصيل عامة",
        failures: "الإخفاقات",
        maintenanceHistory: "تاريخ الصيانة",
      },
      sections: {
        detail: "التفاصيل",
        generalDetail: "التفاصيل العامة",
        usedBy: "مستخدم من قبل",
        equipmentDetails: "تفاصيل المعدات",
        electricityConsumptionDetails: "تفاصيل استهلاك الكهرباء",
        voltageInspectionDetails: "تفاصيل فحص الجهد الكهربائي",
        maintenance: "الصيانة",
        classification: "التصنيف",
        attachment: "المرفق",
      },
      fields: {
        fixedAsset_label: "الأصول الثابتة",
        fixedAsset_placeholder: "حدد الأصل",
        equipmentName_label: "اسم المعدات",
        equipmentName_placeholder: "أدخل اسم المعدات",
        equipmentCategory_label: "فئة المعدات",
        equipmentCategory_placeholder: "حدد فئة المعدات",
        company_label: "شركة",
        company_placeholder: "حدد الشركة",
        alternateEquipment_label: "المعدات البديلة",
        alternateEquipment_placeholder: "حدد المعدات البديلة",
        usedBy_label: "مستخدم من قبل",
        usedBy_department: "قسم",
        usedBy_employee: "الموظف",
        usedBy_other: "آخر",
        workCentre_label: "مركز العمل",
        workCentre_placeholder: "حدد مركز العمل",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
        vendor_label: "البائع",
        vendor_placeholder: "حدد البائع",
        model_label: "نموذج",
        model_placeholder: "أدخل النموذج",
        serialNumber_label: "الرقم التسلسلي",
        serialNumber_placeholder: "أدخل الرقم التسلسلي",
        equipmentCost_label: "تكلفة المعدات",
        equipmentCost_placeholder: "أدخل تكلفة المعدات",
        effectiveDate_label: "تاريخ السريان",
        effectiveDate_placeholder: "حدد تاريخ السريان",
        warrantyExpirationDate_label: "تاريخ انتهاء الضمان",
        warrantyExpirationDate_placeholder: "حدد تاريخ انتهاء الضمان",
        electricityConsumptionDetails_label: "تفاصيل استهلاك الكهرباء",
        voltageInspectionDetails_label: "تفاصيل فحص الجهد الكهربائي",
        maintenance_label: "الصيانة",
        maintenancePeriod_label: "فترة الصيانة",
        maintenancePeriod_placeholder: "حدد الفترة",
        date_label: "التاريخ",
        date_placeholder: "حدد التاريخ",
        lastMaintenanceDate_label: "تاريخ الصيانة الأخيرة",
        lastMaintenanceDate_placeholder: "حدد تاريخ الصيانة الأخيرة",
        makeItRecurring_label: "اجعلها متكررة",
        location_label: "التصنيف",
        location_placeholder: "التصنيف",
        department_label: "قسم",
        department_placeholder: "حدد القسم",
        attachment_image_label: "إرفاق صورة المعدات",
        attachment_document_label: "إرفاق وثائق المعدات",
        upload_label: "رفع",
      },
    },
    workCentreCategories: {
      title: "فئات مركز العمل",
      add_label: "إضافة فئة جديدة",
      edit_label: "تحرير الفئة",
      sections: {
        generalDetail: "تفاصيل عامة",
      },
      fields: {
        name_label: "الاسم",
        categoryTitle_label: "عنوان الفئة",
        name_placeholder: "أدخل الاسم",
        item_label: "العنصر",
        item_placeholder: "اختر العنصر",
        type_label: "النوع",
        type_placeholder: "اختر النوع",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
      },
    },
    workCentre: {
      title: "مركز العمل",
      add_label: "إضافة مركز عمل جديد",
      edit_label: "تعديل مركز العمل",
      sections: {
        generalDetail: "تفاصيل عامة",
        productionDetail: "تفاصيل الإنتاج",
        equipmentDetail: "تفاصيل المعدات",
        attachment: "مرفق",
        workingHours: "ساعات العمل",
      },
      fields: {
        workCentre_label: "مركز العمل",
        workCentre_placeholder: "أدخل اسم مركز العمل",
        workCentreCode_label: "رمز مركز العمل",
        workCentreCode_placeholder: "أدخل رمز مركز العمل",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        alternateWC_label: "مركز عمل بديل",
        alternateWC_placeholder: "اختر مركز العمل البديل",
        usedBy_label: "مستخدم من قبل",
        usedBy_placeholder: "هذه الكفاءة",
        capacity_label: "السعة",
        capacity_placeholder: "أدخل السعة",
        costingDetails_label: "تفاصيل التكلفة",
        costingDetails_placeholder: "",
        setupTime_label: "وقت الإعداد",
        setupTime_placeholder: "أدخل وقت الإعداد بالدقائق",
        cleanUpTime_label: "وقت التنظيف",
        cleanUpTime_placeholder: "أدخل وقت التنظيف بالدقائق",
        equipmentDetails_label: "تفاصيل المعدات",
        equipmentDetails_placeholder: "",
        attachment_label: "إرفاق مستند",
        attachment_placeholder: "إرفاق مستند",
        workingHours_label: "ساعات العمل",
        workingHours_placeholder: "اختر مركز العمل",
        sameForAlldays_label: "نفس الشيء لجميع الأيام",
        sameForAlldays_placeholder: "",
        timeEfficiency_label: "كفاءة الوقت (%)",
        timeEfficiency_placeholder: "أدخل النسبة المئوية",
        oeeTarget_label: "هدف OEE (%)",
        oeeTarget_placeholder: "أدخل النسبة المئوية",
      },

table:{
        srNo_header: "رقم التسلسل",
        workCentre_header: "اسم مركز العمل",
        workCentreCode_header: "الكود",
        capacity_header: "السعة",
        id_header: "المعرف",
        alternativeWC_header: "مركز العمل البديل",
        company_header: "الشركة",
      }
    },
    operation: {
      title: "العمليات",
      add_label: "إضافة عملية جديدة",
      edit_label: "تحرير العملية",
      sections: {
        generalDetail: "تفاصيل عامة",
        costingDetail: "تفاصيل التكلفة",
        instructions: "تعليمات",
      },
      table: {
        srNo_header: "رقم تسلسلي",
        category_header: "الفئة",
        category_placeholder: "اختر الفئة",
        valuePerHour_header: "القيمة لكل ساعة",
        valuePerHour_placeholder: "أدخل التكلفة لكل ساعة",
        valuePerMinute_header: "القيمة لكل دقيقة",
        valuePerMinute_placeholder: "أدخل القيمة",
        fixRate_header: "سعر ثابت",
        fixRate_placeholder: "أدخل السعر الثابت",
        title_header: "العنوان",
        title_placeholder: "أدخل العنوان",
        description_header: "الوصف",
        description_placeholder: "أدخل الوصف",
        attachment_header: "المرفق",
         operationName_header: "اسم العملية",
         id_header: "المعرف",                
      workCentre_header: "مركز العمل",      
      defaultDuration_header: "المدة",     
      actualDurationComputation_header: "حساب المدة", 
      },
      fields: {
        operationName_label: "اسم العملية",
        operationName_placeholder: "أدخل اسم العملية",
        workCentre_label: "مركز العمل",
        workCentre_placeholder: "أدخل اسم مركز العمل",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        defaultDuration_label: "المدة الافتراضية (بالدقائق)",
        defaultDuration_placeholder: "أدخل المدة الافتراضية",
        defaultLabour_label: "العمالة الافتراضية",
        defaultLabour_placeholder: "أدخل العمالة الافتراضية",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
        actualDurationComputation_label: "حساب المدة الفعلية",
        computationBasedOnTrackedTime_label: "احسب بناءً على الوقت المتعقب",
        setDurationManually_label: "تعيين المدة يدويًا",
        copyFrom_label: "نسخ من",
        copyFrom_placeholder: "اختر العملية",
      },
    },
    routing: {
      title: "التوجيه",
      add_label: "إضافة مسار جديد",
      edit_label: "تحرير المسار",
      saveMsg: "تم حفظ المسار بنجاح.",

      sections: {
        generalDetail: "تفاصيل عامة",
        routingDetail: "تفاصيل التوجيه",
      },
      table: {
        no_header: "الرقم.",
        operation_header: "العملية",
        operation_placeholder: "اختر العملية",
        operationSequence_header: "تسلسل العملية",
        operationSequence_placeholder: "أدخل تسلسل العملية",
        rawMaterials_header: "المواد الخام",
        rawMaterials_placeholder: "اختر المواد الخام",
        workCenter_header: "مركز العمل",
        workCenter_placeholder: "اختر مركز العمل",
        durationComputation_header: "حساب المدة الفعلية",
        durationComputation_placeholder: "اختر حساب المدة الفعلية",
        duration_header: "المدة (بالدقائق)",
        narration_header: "الوصف",
      },
      fields: {
        id_label: "المعرف",
        id_placeholder: "أدخل المعرف",
        date_label: "التاريخ",
        date_placeholder: "اختر التاريخ",
        name_label: "الاسم",
        name_placeholder: "أدخل الاسم",
        billOfMaterial_label: "فاتورة المواد",
        billOfMaterial_placeholder: "اختر فاتورة المواد",
        item_label: "العنصر",
        item_placeholder: "اختر العنصر",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        narration_label: "الوصف",
        narration_placeholder: "أدخل الوصف",
        status_label: "الحالة",
        status_placeholder: "حدد الحالة",
        makeItDefaultForLocation_label: "تعيينها كافتراضي للموقع",
      },
    },
    bom: {
      title: "قائمة المواد",
      add_label: "إضافة قائمة مواد",
      edit_label: "تحرير قائمة مواد",
      msg: {
        save: "تم حفظ قائمة المواد بنجاح.",
        requestApproved: "تمت الموافقة على قائمة المواد بنجاح.",
        requestRejected: "تم رفض قائمة المواد بنجاح.",
        requestSubmitted: "تم تقديم قائمة المواد للموافقة.",
        delete: "تم حذف قائمة المواد بنجاح.",
      },

      sections: {
        generalDetail: "تفاصيل عامة",
        materials: "المواد",
      },
      fields: {
        name_label: "الاسم",
        name_placeholder: "أدخل الاسم",
        item_label: "البند",
        item_placeholder: "اختر البند",
        versionNumber_label: "رقم الإصدار",
        versionNumber_placeholder: "أدخل رقم الإصدار",
        quantity_label: "الكمية",
        quantity_placeholder: "أدخل الكمية",
        uom_label: "وحدات القياس",
        uom_placeholder: "اختر وحدات القياس",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        startDate_label: "تاريخ البدء",
        startDate_placeholder: "اختر تاريخ البدء",
        endDate_label: "تاريخ الانتهاء",
        endDate_placeholder: "اختر تاريخ الانتهاء",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        narration_label: "الوصف",
        narration_placeholder: "أدخل الوصف",
        status_label: "الحالة",
      },
      table: {
        item_header: "البند",
        item_placeholder: "اختر البند",
        description_header: "الوصف",
        description_placeholder: "أدخل الوصف",
        quantity_header: "الكمية",
        quantity_placeholder: "أدخل الكمية",
        uom_header: "وحدة القياس",
        uom_placeholder: "اختر وحدة القياس",
        toConsume_header: "الاستهلاك (%)",
        toConsume_placeholder: "أدخل نسبة الاستهلاك (%)",
        scrap_header: "النفايات (%)",
        narration_header: "الوصف",
      },
    },
    jobCards: {
      title: "بطاقات العمل",
      add_label: "إضافة بطاقات العمل",
      edit_label: "تعديل بطاقات العمل",
      operationList_label: "قائمة العمليات",
      completionRecord_label: "سجل الإتمام",
      table: {
        id_header: "الرقم التعريفي",
        date_header: "التاريخ",
        Company_header: "الشركة",
        Location_header: "الموقع",
        Item_header: "العنصر",
        Material_status_header: "حالة المواد",
        uom_header: "وحدة القياس",
        bom_header: "قائمة المواد",
        quantity_header: "الكمية",
        routing_header: "المسار",
        status_header: "الحالة",
        srno_header: "الرقم التسلسلي",
        Description_header: "الوصف",
        available_header: "المتاح",
        reserved_header: "المحجوز",
        on_hand_header: "المتوفر",
        consume_header: "الاستهلاك (%)",
        department_header: "القسم",
        scrap_header: "القصاصات (%)",
        narration_header: "التعليق",
        company_header: "الشركة",
        location_header: "الموقع",
        item_header: "العنصر",
        description_header: "الوصف",
        operation_header: "العملية",
        operation_sequence_header: "ترتيب العمليات",
        raw_material_header: "المواد الخام",
        operation_person_header: "شخص العملية",
        equipment_header: "المعدات",
        work_center_header: "مركز العمل",
        scheduled_start_date_header: "تاريخ بدء الجدول",
        expected_labor_header: "العمالة المتوقعة",
        expected_duration_header: "المدة المتوقعة",
        actual_duration_header: "المدة الفعلية",
        instructions_header: "التعليمات",
        actions_header: "الإجراءات",

        noOfEquipment_header: "عدد المعدات",
        laborResources_header: "موارد العمالة",
        laborSetupTime_header: "وقت إعداد العمالة (بالدقائق)",
        laborRunTime_header: "وقت تشغيل العمالة (بالدقائق)",
        machineResources_header: "موارد الآلات",
        machineSetupTime_header: "وقت إعداد الآلات (بالدقائق)",
        machineRunTime_header: "وقت تشغيل الآلات (بالدقائق)",
        jobCardId_header: "رقم بطاقة العمل",
        workOrderId_header: "رقم أمر العمل",
      },
      sections: {
        generalDetail: "التفاصيل العامة",
        material: "المواد",
        routingDetails: "تفاصيل المسار",
        classification: "التصنيف",
      },
      fields: {
        id_label: "الرقم التعريفي",
        id_placeholder: "يرجى إدخال الرقم التعريفي",
        date_label: "التاريخ",
        date_placeholder: "يوم-شهر-سنة",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        item_label: "العنصر",
        item_placeholder: "اختر العنصر",
        uom_label: "وحدة القياس (UoM)",
        uom_placeholder: "اختر وحدة القياس",
        bom_label: "قائمة المواد",
        bom_placeholder: "اختر قائمة المواد",
        quantity_label: "الكمية",
        quantity_placeholder: "أدخل الكمية",
        routing_label: "المسار",
        routing_placeholder: "اختر المسار",
        manufacturing_time_label: "وقت التصنيع",
        manufacturing_time_placeholder: "أدخل وقت التصنيع",
        production_start_date_label: "تاريخ بدء الإنتاج",
        production_start_date_placeholder: "يوم-شهر-سنة",
        production_end_date_label: "تاريخ انتهاء الإنتاج",
        production_end_date_placeholder: "يوم-شهر-سنة",
        reference_number_label: "الرقم المرجعي",
        reference_number_placeholder: "أدخل الرقم المرجعي",
        responsible_person_label: "الشخص المسؤول",
        responsible_person_placeholder: "اختر الشخص المسؤول",
        narration_label: "التعليق",
        narration_placeholder: "أدخل التعليق",
        department_label: "القسم",
        department_placeholder: "اختر القسم",

        workOrder_label: "أمر العمل",
        workOrder_placeholder: "إضافة أمر العمل",
        jobCard_label: "بطاقة العمل",
        jobCard_placeholder: "إضافة بطاقة العمل",
        builtQuantity_label: "الكمية المُصنّعة",
      },
      msg: {
        save: "تم حفظ بطاقة العمل بنجاح.",
        closed: "تم إغلاق بطاقة العمل بنجاح.",
        cancelled: "تم إلغاء بطاقة العمل بنجاح.",
        released: "تم إصدار بطاقة العمل",
        delete: "تم حذف بطاقة العمل بنجاح.",
        noOperationRemaining: "تمت إضافة جميع العمليات إلى الإتمام",
        recordCompletionSave: "تم حفظ إتمام السجل بنجاح",
      },
      buttons: {
        recordCompletion_label: "تسجيل الإتمام",
        completion_label: "الإتمام",
      },
    },

    buildOrder: {
      title: "أمر البناء",
      add_label: "إضافة أمر بناء جديد",
      edit_label: "تعديل أمر البناء",
      sections: {
        generalDetail: "التفاصيل العامة",
        materials: "المواد",
        classification: "التصنيف",
      },
      fields: {
        WorkOrder_label: "أمر العمل",
        WorkOrder_label_placeholder: "أدخل أمر العمل",
        Id: "الرقم",
        Id_placeholder: "أدخل الرقم",
        Date: "التاريخ",
        Date_placeholder: "DD-MM-YYYY",
        Company_label: "الشركة",
        Company_label_placeholder: "اختر الشركة",
        location_label: "الموقع",
        location_label_placeholder: "اختر الموقع",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
        items_label: "العناصر",
        items_placeholder: "اختر العناصر",
        uom_label: "وحدة القياس",
        uom_placeholder: "اختر وحدة القياس",
        bom_label: "قائمة المواد",
        bom_placeholder: "اختر قائمة المواد",
        Quantity: "الكمية",
        Quantity_placeholder: "أدخل الكمية",
        Routing_label: "التوجيه",
        Routing_placeholder: "اختر التوجيه",
        department_label: "القسم",
        department_placeholder: "اختر القسم",
        cleanUpTime_label: "وقت التنظيف",
        cleanUpTime_placeholder: "أدخل وقت التنظيف بالدقائق",
        equipmentDetails_label: "تفاصيل المعدات",
        equipmentDetails_placeholder: "",
        attachment_label: "إرفاق مستند",
        attachment_placeholder: "إرفاق مستند",
        workingHours_label: "ساعات العمل",
        workingHours_placeholder: "اختر أمر البناء",
        sameForAlldays_label: "نفس الأيام",
        sameForAlldays_placeholder: "",
        timeEfficiency_label: "كفاءة الوقت (%)",
        timeEfficiency_placeholder: "أدخل النسبة المئوية",
        oeeTarget_label: "هدف OEE (%)",
        oeeTarget_placeholder: "أدخل النسبة المئوية",
      },
    },
    workOrder: {
      title: "أمر العمل",
      add_label: "إضافة أمر عمل",
      edit_label: "تعديل أمر العمل",
      workOrderDetails_label: "تفاصيل أمر العمل",
      materialIssueDetails_label: "تفاصيل إصدار المواد",
      addMaterialIssue_label: "إضافة إصدار المواد",
      materialIssueed_label: "تفاصيل إصدار المواد",
      issuedMaterials_label: "المواد المصدرة",
      issueMaterial_label: "إصدار المواد",
      msg: {
        save: "تم حفظ أمر العمل بنجاح.",
        closed: "تم إغلاق أمر العمل بنجاح.",
        cancelled: "تم إلغاء أمر العمل بنجاح.",
        released: "تم إصدار أمر العمل",
        delete: "تم حذف أمر العمل بنجاح.",
      },
      sections: {
        generalDetail: "التفاصيل العامة",
        clasification: "التصنيف",
        materials: "المواد",
      },
      fields: {
        id_label: "رقم التعريف",
        id_placeholder: "أدخل رقم التعريف",
        date_label: "التاريخ",
        date_placeholder: "اختر التاريخ",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        item_label: "البند",
        item_placeholder: "اختر البند",
        uom_label: "وحدة القياس",
        uom_placeholder: "اختر وحدة القياس",
        billOfMaterial_label: "قائمة المواد",
        billOfMaterial_placeholder: "اختر قائمة المواد",
        quantity_label: "الكمية",
        quantity_placeholder: "أدخل الكمية",
        routing_label: "التوجيه",
        routing_placeholder: "اختر التوجيه",
        manufacturingTime_label: "وقت التصنيع",
        manufacturingTime_placeholder: "أدخل وقت التصنيع",
        productionStartDate_label: "تاريخ بدء الإنتاج",
        productionStartDate_placeholder: "اختر تاريخ بدء الإنتاج",
        productionEndDate_label: "تاريخ انتهاء الإنتاج",
        productionEndDate_placeholder: "اختر تاريخ انتهاء الإنتاج",
        referenceNumber_label: "رقم المرجع",
        referenceNumber_placeholder: "أدخل رقم المرجع",
        responsiblePerson_label: "الشخص المسؤول",
        responsiblePerson_placeholder: "اختر الشخص المسؤول",
        narration_label: "السرد",
        narration_placeholder: "أدخل السرد",
        department_label: "القسم",
        department_placeholder: "اختر القسم",
      },
      table: {
        item_header: "البند",
        description_header: "الوصف",
        uom_header: "وحدة القياس",
        quantity_header: "الكمية",
        available_header: "المتوفر",
        available_placeholder: "أدخل الكمية المتوفرة",
        reserved_header: "المحجوز",
        reserved_placeholder: "أدخل الكمية المحجوزة",
        onHand_header: "الموجود",
        onHand_placeholder: "أدخل الكمية الموجودة",
        classification_header: "التصنيف",
        classification_placeholder: "اختر القسم",
        consume_header: "الاستهلاك (%)",
        consume_placeholder: "أدخل نسبة الاستهلاك (%)",
        scrap_header: "الهدر (%)",
        narration_header: "السرد",
        company_header: "الشركة",
        location_header: "الموقع",
        bom_header: "قائمة المواد",
        routing_header: "التوجيه",
      },
    },
  },
  crm: {
    name: "إدارة علاقات العملاء",
    title: "هذه هي وحدة إدارة علاقات العملاء",
    leads: {
      title: "العملاء المحتملين",
      add_label: "إضافة عميل محتمل جديد",
      edit_label: "تعديل العميل المحتمل",
      msg: {
        save: "تم حفظ العميل المحتمل بنجاح.",
        delete: "تم حذف العميل المحتمل بنجاح.",
        error: "حدث خطأ أثناء معالجة العميل المحتمل.",
      },
      sections: {
        generalDetail: "التفاصيل العامة",
        address: "العنوان",
        contact: "جهات الاتصال",
        followUp: "المتابعة",
        ownerDetails: "تفاصيل مالك العميل",
        classification: "التصنيف",
        attachments: "المرفقات",
      },
      fields: {
        type_lable: "النوع",
        id_label: "المعرف",
        id_placeholder: "أدخل المعرف",
        firstName_label: "الاسم الأول",
        firstName_placeholder: "أدخل الاسم الأول",
        middleName_label: "الاسم الأوسط",
        middleName_placeholder: "أدخل الاسم الأوسط",
        lastName_label: "الاسم الأخير",
        lastName_placeholder: "أدخل الاسم الأخير",
        name_label: "الاسم",
        type_label:'النوع',
        name_placeholder: "أدخل اسم العميل المحتمل",
        lead_company_label: "شركة العميل المحتمل",
        company_label: "الشركة",
        company_placeholder: "أدخل اسم الشركة",
        phone_label: "رقم الهاتف",
        phone_placeholder: "أدخل رقم الهاتف",
        email_label: "البريد الإلكتروني",
        email_placeholder: "أدخل البريد الإلكتروني",
        website_label: "الموقع الإلكتروني",
        website_placeholder: "أدخل رابط الموقع",
        status_label: "الحالة",
        status_placeholder: "اختر الحالة",
        conversion_probability_label: "احتمالية التحويل",
        reference_number_label: "الرقم المرجعي",
        reference_number_placeholder: "أدخل الرقم المرجعي",
        leadSource_label: "المصدر",
        leadSource_placeholder: "اختر المصدر",
        salesPerson_label: "مندوب المبيعات",
        salesPerson_placeholder: "اختر مندوب المبيعات",
        phoneNumber_label: "رقم الهاتف",
        phoneNumber_placeholder: "أدخل رقم الهاتف",
        industry_label: "الصناعة",
        industry_placeholder: "اختر الصناعة",
        currency_label: "العملة",
        currency_placeholder: "اختر العملة",
        priority_label: "الأولوية",
        priority_placeholder: "اختر الأولوية",
        narration_label: "الوصف",
        narration_placeholder: "أدخل الملاحظات أو الوصف",
        location_label: "الموقع",
        location_placeholder: "اختر الموقع",
        department_label: "القسم",
        department_placeholder: "اختر القسم",
        annualRevenue_label: "الإيرادات السنوية",
        annualRevenue_placeholder: "أدخل الإيرادات السنوية",
        view_attachment_label: "الملف المرفق",
        customer_label: "العميل",
        lead_status_label: "حالة العميل المحتمل",
        responsible_person_label: "الشخص المسؤول",
        responsible_person_placeholder: "اختر الشخص المسؤول",
      },
      table: {
        id_header: "المعرف",
        name_header: "الاسم",
        company_header: "الشركة",
        status_header: "الحالة",
        lead_status_header: "حالة العميل المحتمل",
        owner_header: "المالك",
        source_header: "المصدر",

        followUpType_header: "نوع المتابعة",
        followUpDateTime_header: "تاريخ ووقت المتابعة",
        remindMe_header: "تذكير",
        description_header: "الوصف",

        addressType_header: "نوع العنوان",
        addressee_header: "المستلم",
        defaultShippingAddress_header: "عنوان الشحن الافتراضي",
        defaultBillingAddress_header: "عنوان الفوترة الافتراضي",
        countryCode_header: "رمز الدولة",
        contactNumber_header: "رقم الاتصال",
        addrressOne_header: "العنوان 1",
        addressTwo_header: "العنوان 2",
        addressThree_header: "العنوان 3",
        zipCode_header: "الرمز البريدي",
        city_header: "المدينة",
        state_header: "الولاية/المحافظة",
        country_header: "الدولة",
        summary_header: "ملخص",

        email_header: "البريد الإلكتروني",
      },
      tabs: {
        basicDetails: "التفاصيل الأساسية",
        address: "العنوان",
        contact: "جهات الاتصال",
      },
    },
    customerSegment: {
      title: "شرائح العملاء",
      add_label: "إضافة شريحة جديدة",
      edit_label: "تعديل شريحة العميل",
      msg: {
        save: "تم حفظ شريحة العميل بنجاح.",
        requestApproved: "تمت الموافقة على شريحة العميل بنجاح.",
        requestRejected: "تم رفض شريحة العميل بنجاح.",
        requestSubmitted: "تم تقديم شريحة العميل للموافقة.",
        delete: "تم حذف شريحة العميل بنجاح.",
      },

      sections: {
        generalDetail: "تفاصيل عامة",
        conditions: "الشروط",
        attachment: "المرفقات",
      },
      fields: {
        id_label: "الهوية",
        id_placeholder: "أدخل الهوية",
        name_label: "الاسم",
        name_placeholder: "أدخل الاسم",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        startDate_label: "تاريخ البدء",
        startDate_placeholder: "اختر تاريخ البدء",
        endDate_label: "تاريخ الانتهاء",
        endDate_placeholder: "اختر تاريخ الانتهاء",
        narration_label: "الوصف",
        narration_placeholder: "اكتب الوصف",
        autoAssign_label: "التعيين التلقائي",

        purchaseAmount_label: "مبلغ الشراء",
        purchaseAmount_placeholder: "أدخل مبلغ الشراء",
        purchaseCount_label: "عدد المشتريات",
        purchaseCount_placeholder: "أدخل عدد المشتريات",
        segmentDuration_label: "مدة الشريحة",
        segmentDuration_placeholder: "اختر التاريخ",

        attachment_label: "إرفاق مستند",
        view_attachment_label: "الملف المرفق",
        attachment_placeholder: "أرفق ملفك هنا",
        upload_label: "رفع",
      },
      table: {
        id_header: "الهوية",
        segmentName_header: "اسم الشريحة",
        segmentDuration_header: "مدة الشريحة",
        purchaseAmount_header: "مبلغ الشراء",
        purchaseCount_header: "عدد المشتريات",
        validityStartDate_header: "تاريخ بدء الصلاحية",
        validityEndDate_header: "تاريخ انتهاء الصلاحية",
        company_header: "الشركة",
        status_header: "الحالة",
      },
    },
  },
  procurement: {
    name: "Procurement",
    title: "This is PROCUREMENT module",
    requestForQuote: {
      title: "طلب عرض سعر",
      add_label: "إضافة طلب عرض سعر جديد",
      add_response_label: "إضافة استجابة لطلب عرض سعر جديد",
      edit_label: "تعديل طلب عرض سعر",
      edit_response_label: "تعديل استجابة طلب عرض سعر",
      detail_label: "تفاصيل طلب عرض السعر",
      previouse_price_msg: "عرض الأسعار السابقة",
      response_title: "الردود",
      alredy_awarded:
        "لقد اخترت بالفعل المورد لهذا البند. هل تريد تحديث تفاصيل المورد؟",
      msg: {
        save: "تم حفظ طلب عرض السعر بنجاح.",
        delete: "تم حذف طلب عرض السعر بنجاح.",
        cancel: "هل أنت متأكد أنك تريد الإلغاء؟",
        error: "حدث خطأ أثناء معالجة طلب عرض السعر.",
        tendor: "دعوة للمناقصة",
      },
      button: {
        response: "الاستجابة",
        order: "طلب",
        agreement: "اتفاقية",
        rfq: "طلب عرض سعر",
        orders: "الطلبات",
      },
      tabs: {
        basicDetails: "التفاصيل الأساسية",
        addressAndContact: "العنوان وجهة الاتصال",
      },
      sections: {
        generalDetail: "التفاصيل الأساسية",
        upload: "المرفقات",
        classification: "التصنيف",
        items: "العناصر",
        discounts: "الخصومات",
        call_for_tender: "دعوة للمناقصة",
      },
      dropdown: {
        print: "طباعة طلب عرض السعر",
        sendEmail: "إرسال بريد إلكتروني",
      },
      fields: {
        id_label: "الرقم التعريفي",
        id_placeholder: "الرقم التعريفي",
        date_label: "التاريخ",
        date_placeholder: "اختر التاريخ",
        copy_product: "نسخ المنتج",
        rfq_id_label: "معرّف طلب عرض السعر",
        department_label: "القسم",
        department_placeholder: "اختر القسم",
        orderDeadline_label: "الموعد النهائي للطلب",
        orderDeadline_placeholder: "اختر التاريخ",
        expectedRequiredDate_label: "التاريخ المتوقع",
        expectedRequiredDate_placeholder: "اختر التاريخ",
        purchaseRepresentavive_label: "ممثل المشتريات",
        purchaseRepresentavive_placeholder: "اختر ممثل المشتريات",
        paymentTerm_label: "شروط الدفع",
        paymentTerm_placeholder: "اختر شروط الدفع",
        referenceNo_label: "رقم المرجع",
        lead_label: "مدة التنفيذ",
        lead_placeholder: "أدخل مدة التنفيذ",
        referenceNo_placeholder: "أدخل رقم المرجع",
        narration_label: "الوصف",
        narration_placeholder: "أدخل الوصف",
        attachment_label: "أرفق ملفك هنا",
        supplierAddress_label: "عنوان المورد",
        supplierAddress_placeholder: "اختر عنوان المورد",
        contactPerson_label: "جهة الاتصال",
        contactPerson_placeholder: "اختر جهة الاتصال",
        vendor_header: "المورد",
        purchaseRepresentative_header: "ممثل المشتريات",
        company_label: "الشركة",
        company_placeholder: "اختر الشركة",
        location_label: "الموقع",
        order_deadline_label: "الموعد النهائي للطلب",
        expected_required_date_label: "التاريخ المتوقع",
        currency_label: "العملة",
        currency_placeholder: "اختر العملة",
        exchangeRate_label: "سعر الصرف",
        view_attachment_label: "الملف المرفق",
        vendor_label: "المورد",
        vendor_placeholder: "اختر المورد",
        location_placeholder: "اختر الموقع",
        exchangeRate_placeholder: "أدخل سعر الصرف",
        incoterms_label: "شروط التجارة الدولية",
        incoterms_placeholder: "اختر شروط التجارة الدولية",
        condition_header: "الشرط",
        rate_header: "المعدل",
      },
      table: {
        id_header: "الرقم التعريفي",
        date_header: "التاريخ",
        awarded_header: "تم التعاقد",
        purchaseRepresentavive_label: "ممثل المشتريات",
        customer_header: "العميل",
        salesOrderStatus_header: "حالة طلب البيع",
        invoiceStatus_header: "حالة الفاتورة",
        deliveryStatus_header: "حالة التسليم",
        salesperson_header: "مندوب المبيعات",
        company_header: "الشركة",
        item_header: "العنصر",
        item_header_placeholder: "اختر العنصر",
        orderDeadline_label: "الموعد النهائي للطلب",
        expectedRequiredDate_label: "التاريخ المتوقع",
        uom_header: "وحدة القياس",
        requested_uom_header: "وحدة القياس المطلوبة",
        vendor_uom_header: "وحدة القياس الخاصة بالمورد",
        notes_header: "ملاحظات",
        currency_label: "العملة",
        minimum_order_quantity: "الحد الأدنى للطلب",
        uom_header_placeholder: "اختر وحدة القياس",
        description_header: "الوصف",
        description_header_placeholder: "أدخل الوصف",
        expected_required_date_header: "التاريخ المتوقع",
        expectedShippingDate_header_placeholder: "اختر التاريخ المتوقع",
        quantity_header: "الكمية",
        quantity_header_placeholder: "أدخل الكمية",
        rate_header: "المعدل",
        rate_header_placeholder: "أدخل المعدل",
        available_header: "المتوفر",
        onHand_header: "المتوفر في اليد",
        reserved_header: "محجوز",
        backOrdered_header: "الطلب المؤجل",
        invoiced_header: "تم الفوترة",
        delivered_header: "تم التسليم",
        grossAmount_header: "المبلغ الإجمالي",
        discountItem_header: "العنصر المخفض",
        discountedAmount_header: "المبلغ المخفض",
        discountRate_header: "معدل الخصم",
        netAmount_header: "المبلغ الصافي",
        taxTemplate_header: "نموذج الضريبة",
        taxAmount_header: "مبلغ الضريبة",
        totalAmount_header: "المبلغ الإجمالي",
        location_header: "الموقع",
        department_header: "القسم",
        narration_header: "الوصف",
        gross_amount_header: "المبلغ الإجمالي",
        couponCode_header: "رمز الكوبون",
        account_header: "الحساب",
        type_header: "النوع",
        promotionAmount_header: "مبلغ / نسبة الترويج",
        promotion_amount_header: "مبلغ الترويج",
        discountAmount_header: "مبلغ الخصم",
        referenceNo_header: "رقم المرجع",
        vendor_header: "المورد",
        status_header: "الحالة",
        purchase_order_header: "طلب الشراء",
        specification_header: "المواصفات",
        requested_quanity_header: "الكمية المطلوبة",
        estimated_quantity_header: "الكمية المقدرة السنوية",
        classification_header: "التصنيف",
        rfq_header: "معرّف طلب عرض السعر",
        condition_header: "الشرط",
        response_id_header: "رقم الرد",
        response_date_header: "تاريخ الرد",
        lead_time_header: "مدة التنفيذ",
        response_message_header: "رسالة الرد",
        vendor_id_header: "رقم المورد",
        vendor_name_header: "اسم المورد",
        rate_in_base_currency: "السعر بالعملة الأساسية",
        rate_in_foreign_currency: "السعر بالعملة الأجنبية",
      },
    },
  },

  rental: {
		name: 'التأجير',
		title: 'هذا هو وحدة التأجير',
		settings: {
			termsAndConditions: {
				title: 'الشروط والأحكام',
				add_label: 'إضافة جديد',
				edit_label: 'المعرف: :id',
				table: {
					id: 'المعرف',
					name: 'الاسم',
					status: 'الحالة'
				},
				fields: {
					id: 'المعرف',
					id_placeholder: 'أدخل المعرف',
					name: 'الاسم',
					name_placeholder: 'أدخل الاسم',
					status: 'الحالة',
					terms_and_condition_placeholder: 'اكتب الشروط والأحكام هنا'
				},
				msg: {
					delete: 'تم حذف الشروط والأحكام :id بنجاح'
				}
			},
      configuration: {
				title: 'الإعدادات',
				add_label: 'إضافة جديد',
				edit_label: 'المعرف: :id',
				fields: {
					initial_invoicing: 'تمكين الفوترة الأولية',
					inventory_status: 'تمكين حالة المخزون',
					no_of_days: 'عدد الأيام',
					no_of_days_placeholder: 'أدخل العدد'
				},
				msg: {
					save: 'تم حفظ الإعدادات بنجاح'
				}
			}
		},
    opportunity: {
      title: "الفرص",
      add_label: "إضافة فرصة",
      edit_label: "تعديل فرصة",
      view_label: "تفاصيل الفرصة",
      view_sales_pipeline: "مسار المبيعات",
      msg: {
      save: "تم حفظ الفرصة بنجاح.",
      requestApproved: "تمت الموافقة على الفرصة بنجاح.",
      requestRejected: "تم رفض الفرصة بنجاح.",
      requestSubmitted: "تم إرسال الفرصة للموافقة",
      delete: "تم حذف الفرصة بنجاح.",
      },
      tabs: {
      basic_details: "التفاصيل الأساسية",
      address: "العنوان",
      contact: "الاتصال",
      promotion: "العروض الترويجية",
      },
      sections: {
      generalDetail: "التفاصيل العامة",
      items: "العناصر",
      attachment: "المرفق",
      follow_up: "المتابعة",
      ownerDetail: "تفاصيل مالك الفرصة",
      classification: "التصنيف",
      amount: "المبلغ",
      tax: "الضريبة",
      add_follow_up: "إضافة تاريخ ووقت المتابعة",
      attachments: "المرفقات",
      },
      button: {
      apply_promotion: "تطبيق العروض",
      apply: "تطبيق",
      },
      fields: {
      id_label: "المعرف",
      id_placeholder: "أدخل المعرف",
      name_label: "الاسم",
      name_placeholder: "أدخل الاسم",
      item_label: "العنصر",
      item_placeholder: "اختر العنصر",
      type_label: "النوع",
      type_placeholder: "اختر النوع",
      versionNumber_label: "رقم الإصدار",
      versionNumber_placeholder: "أدخل رقم الإصدار",
      quantity_label: "الكمية",
      quantity_placeholder: "أدخل الكمية",
      uom_label: "وحدة القياس",
      uom_placeholder: "اختر وحدة القياس",
      attachment_label: "إرفاق مستند",
      company_label: "الشركة",
      company_placeholder: "اختر الشركة",
      startDate_label: "تاريخ البدء",
      startDate_placeholder: "اختر تاريخ البدء",
      endDate_label: "تاريخ الانتهاء",
      endDate_placeholder: "اختر تاريخ الانتهاء",
      expiryDate_label: "تاريخ الانتهاء",
      expiryDate_placeholder: "اختر تاريخ الانتهاء",
      location_label: "الموقع",
      location_placeholder: "اختر الموقع",
      narration_label: "السرد",
      narration_placeholder: "أدخل السرد",
      status_label: "الحالة",
      limit_label: "الحد",
      limit_placeholder: "أدخل الحد",
      usage_limit_label: "حد الاستخدام",
      limit_usage_label: "حد الاستخدام",
      account_label: "الحساب",
      percentage_label: "النسبة المئوية",
      fixed_amount_label: "المبلغ الثابت",
      buy_x_get_y_label: "اشترِ X واحصل على Y",
      coupon_number_header: "عدد القسائم",
      coupon_number_placeholder: "أدخل عدد القسائم",
      contact_header: "جهة الاتصال",
      contact_placeholder: "اختر جهة الاتصال",
      closing_date_header: "تاريخ الإغلاق المتوقع",
      closing_date_placeholder: "اختر تاريخ الإغلاق المتوقع",
      expected_revenue_header: "العائد المتوقع",
      expected_revenue_placeholder: "أدخل العائد المتوقع",
      stage_header: "المرحلة",
      stage_placeholder: "اختر المرحلة",
      probability_header: "الاحتمالية",
      WinLoss_reason_header: "سبب الفوز/الخسارة",
      WinLoss_reason_placeholder: "اختر سبب الفوز/الخسارة",
      phone_number_header: "رقم الهاتف",
      phone_number_placeholder: "أدخل رقم الهاتف",
      email_header: "البريد الإلكتروني",
      email_placeholder: "أدخل البريد الإلكتروني",
      website_header: "الموقع الإلكتروني",
      website_placeholder: "أدخل الموقع الإلكتروني",
      currency_header: "العملة",
      currency_placeholder: "اختر العملة",
      exchance_rate_header: "سعر الصرف",
      reference_no_header: "رقم المرجع",
      reference_no_placeholder: "أدخل رقم المرجع",
      priority_header: "الأولوية",
      priority_placeholder: "اختر الأولوية",
      salesperson_header: "مندوب المبيعات",
      salesperson_placeholder: "اختر مندوب المبيعات",
      source_header: "المصدر",
      source_placeholder: "اختر المصدر",
      industry_header: "الصناعة",
      industry_placeholder: "اختر الصناعة",
      department_label: "القسم",
      department_placeholder: "اختر القسم",
      status_header: "الحالة",
      coupon_code_label: "رمز القسيمة",
      coupon_code_placeholder: "أدخل رمز القسيمة",
      delivery_commitment_date_label: "تاريخ الالتزام بالتسليم",
      delivery_commitment_date_placeholder: "أدخل تاريخ الالتزام بالتسليم",
      expected_shipping_date_label: "تاريخ الشحن المتوقع",
      expected_shipping_date_placeholder: "اختر تاريخ الشحن المتوقع",
      rate_label: "المعدل",
      rate_placeholder: "أدخل المعدل",
      available_label: "متاح",
      onhand_label: "متوفر",
      reserved_label: "محجوز",
      discount_item_label: "عنصر الخصم",
      discount_item_placeholder: "اختر عنصر الخصم",
      discount_rate_label: "معدل الخصم",
      gross_amount_label: "المبلغ الإجمالي",
      net_amount_label: "المبلغ الصافي",
      tax_amount_label: "مبلغ الضريبة",
      discount_amount_label: "مبلغ الخصم",
      total_amount_label: "المبلغ الإجمالي",
      tax_template_label: "قالب الضريبة",
      tax_template_placeholder: "اختر قالب الضريبة",
      follow_up_type_label: "نوع المتابعة",
      follow_up_type_placeholder: "اختر نوع المتابعة",
      remind_me_label: "ذكرني",
      remind_me_placeholder: "اختر الوقت",
      date_label: "التاريخ",
      date_placeholder: "أدخل التاريخ",
      time_label: "الوقت",
      time_placeholder: "أدخل الوقت",
      address_type_label: "نوع العنوان",
      address_type_placeholder: "اختر نوع العنوان",
      addressee_label: "المُرسل إليه",
      addressee_placeholder: "أدخل اسم المُرسل إليه",
      address_label: "العنوان",
      address_placeholder: "أدخل العنوان",
      zip_code_label: "الرمز البريدي",
      zip_code_placeholder: "أدخل الرمز البريدي",
      city_label: "المدينة",
      city_placeholder: "اختر المدينة",
      state_label: "الولاية",
      state_placeholder: "اختر الولاية",
      country_label: "الدولة",
      country_placeholder: "اختر الدولة",
      summary_label: "الملخص",
      view_attachment_label: "الملف المرفق",
      },
      },
    
    orders: {
      quotation: {
        title: 'عروض الأسعار',
        addLabel: 'إضافة عرض سعر جديد',
        editLabel: 'المعرف :id',
        table: {
          id: 'المعرف',
          date: 'التاريخ',
          customer: 'العميل',
          status: 'الحالة',
          salesPerson: 'مندوب المبيعات',
          item: 'العنصر',
          uom: 'وحدة القياس',
          description: 'الوصف',
          deliveryCommitmentDate: 'تاريخ الالتزام بالتسليم',
          expectedShippingDate: 'تاريخ الشحن المتوقع',
          quantity: 'الكمية',
          priceList: 'قائمة الأسعار',
          rate: 'السعر',
          replacementCost: 'تكلفة الاستبدال',
          available: 'المتوفر',
          onHand: 'المخزون المتاح',
          reserved: 'المحجوز',
          discountedItem: 'العنصر المخفض',
          discountRate: 'نسبة الخصم',
          grossAmount: 'المبلغ الإجمالي',
          taxAmount: 'قيمة الضريبة',
          discountAmount: 'قيمة الخصم',
          netAmount: 'المبلغ الصافي',
          totalAmount: 'المبلغ الإجمالي',
          taxTemplate: 'قالب الضريبة',
          taxRate: 'معدل الضريبة',
          location: 'الموقع',
          department: 'القسم',
          narration: 'السرد',
          couponCode: 'كود القسيمة',
          account: 'الحساب',
          type: 'النوع',
          promotionAmountOrPercent: 'مبلغ الترويج / %'
        },
        fields: {
          id_label: 'المعرف',
          id_placeholder: 'أدخل المعرف',
          date_label: 'التاريخ',
          date_placeholder: 'حدد التاريخ',
          customer_label: 'العميل',
          customer_placeholder: 'حدد العميل',
          paymentTerms_label: 'شروط الدفع',
          paymentTerms_placeholder: 'حدد شروط الدفع',
          company_label: 'الشركة',
          company_placeholder: 'حدد الشركة',
          expirationDate_label: 'تاريخ الانتهاء',
          expirationDate_placeholder: 'حدد التاريخ',
          deliveryCommitment_label: 'تاريخ الالتزام بالتسليم',
          deliveryCommitment_placeholder: 'حدد التاريخ',
          currency_label: 'العملة',
          currency_placeholder: 'حدد العملة',
          exchangeRate_label: 'سعر الصرف',
          exchangeRate_placeholder: 'أدخل سعر الصرف',
          salesPerson_label: 'مندوب المبيعات',
          salesPerson_placeholder: 'حدد مندوب المبيعات',
          referenceNumber_label: 'رقم المرجع',
          referenceNumber_placeholder: 'أدخل رقم المرجع',
          status_label: 'الحالة',
          status_placeholder: 'حدد الحالة',
          version_label: 'رقم الإصدار',
          version_placeholder: 'رقم الإصدار',
          termsCondition_label: 'الشروط والأحكام',
          termsCondition_placeholder: 'حدد الشروط والأحكام',
          narration_label: 'السرد',
          narration_placeholder: 'اكتب السرد',
          startDateTime_label: 'تاريخ ووقت البدء',
          startDateTime_plcaeholder: 'حدد تاريخ ووقت البدء',
          endDateTime_label: 'تاريخ ووقت الانتهاء',
          endDateTime_plcaeholder: 'حدد تاريخ ووقت الانتهاء',
          totalPeriod_label: 'الفترة الإجمالية',
          totalPeriod_plcaeholder: '-',
          billingCycle_label: 'دورة الفوترة',
          billingCycle_plcaeholder: 'حدد دورة الفوترة',
          lastInvoiceDate_label: 'تاريخ الفاتورة الأخيرة',
          lastInvoiceDate_plcaeholder: 'حدد التاريخ',
          nextInvoiceDate_label: 'تاريخ الفاتورة التالية',
          nextInvoiceDate_plcaeholder: 'حدد التاريخ',
          shippingAddress_label: 'عنوان الشحن',
          shippingAddress_placeholder: 'حدد عنوان الشحن',
          contactPerson_label: 'الشخص المسؤول',
          contactPerson_placeholder: 'حدد الشخص المسؤول',
          billingAddress_label: 'عنوان الفوترة',
          billingAddress_placeholder: 'حدد عنوان الفوترة',
          placeOfSupply_label: 'مكان التوريد',
          placeOfSupply_placeholder: 'حدد مكان التوريد',
          postingTime_label: 'وقت النشر',
          postingTime_placeholder: 'HH:MM PM',
          recurring_label: 'متكرر',
          recurring_placeholder: 'حدد التكرار',
          upload_label: 'تحميل',
          additionalDiscountOn_label: 'تطبيق خصم إضافي على',
          additionalDiscountOn_placeholder: 'الخصم الإضافي',
          additionalDiscountPercent_label: 'نسبة الخصم الإضافي',
          additionalDiscountPercent_placeholder: 'أدخل نسبة الخصم الإضافي',
          roundOff_label: 'التقريب',
          roundOff_placeholder: 'حدد التقريب',
          roundOff_amount: 'قيمة التقريب',
          cashOrNonTrade_label: 'هل هو خصم نقدي أو غير تجاري',
          shippingRule_label: 'قاعدة الشحن',
          shippingRule_placeholder: 'حدد قاعدة الشحن',
          shippingCost_label: 'تكلفة الشحن',
          shippingCost_placeholder: 'أدخل تكلفة الشحن'
        },
        sections: {
          basicDetails: 'التفاصيل الأساسية',
          rentalPeriod: 'فترة التأجير',
          billing: 'الفوترة',
          items: 'العناصر',
          discounts: 'الخصومات',
          classification: 'التصنيف',
          attachment: 'المرفقات',
          amount: 'المبلغ',
          tax: 'الضريبة',
          shippingAddress: 'عنوان الشحن',
          billingAddress: 'عنوان الفوترة'
        },
        msg: {
          delete: 'تم حذف عرض السعر :id بنجاح',
          save: 'تم حفظ عرض السعر بنجاح',
          update: 'تم تحديث عرض السعر :id بنجاح'
        },
        tabs: {
          basicDetails: 'التفاصيل الأساسية',
          addressAndContact: 'العنوان وجهات الاتصال',
          shipping: 'الشحن',
          promotions: 'العروض الترويجية'
        }
      }
    },
    invoice: {
      title: "فواتير طلبات الإيجار",
      jobTitle: 'الوظائف',
      routes: {
          job: 'الوظيفة'
      },
      filters: {
          date: 'التاريخ',
          date_placeholder: 'اختر التاريخ',
          invoice_date: 'تاريخ الفاتورة',
          invoice_date_placeholder: 'اختر تاريخ الفاتورة',
          customer_label: "اختر العميل",
          customer_placeholder: 'ابحث عن العميل',
          subsidiary_label: "اختر الفرع",
          subsidiary_placeholder: 'ابحث عن الفرع'
      },
      fields: {
          type_label: "النوع",
          type_placeholder: "اختر النوع",
          subsidiary_label: "الفرع",
          subsidiary_placeholder: "اختر الفرع",
          location_label: "الموقع",
          location_placeholder: "اختر الموقع",
          asOfDate_label: "اعتباراً من التاريخ",
          asOfDate_placeholder: "اختر التاريخ",
          showBelowReorderPoint_label: "إظهار تحت نقطة إعادة الطلب",
      },
      invoiceDialog: {
          title: 'اختر تاريخ الفاتورة',
          date_label: 'تاريخ الفاتورة',
          date_placeholder: 'أدخل تاريخ الفاتورة'
      },
      table: {
          item_header: "العنصر",
          description_header: "الوصف",
          units_header: "الوحدات",
          demand_header: "الطلب",
          onHand_header: "المتوفر",
          onOrder_header: "الطلبات",
          available_header: "المتاح",
          committed_header: "الملتزم به",
          pr_header: "طلب شراء",
          required_header: "المطلوب",
          date: "التاريخ",
          transaction: "المعاملة",
          location: "الموقع",
          quantity: "الكمية",
          raw_material: "المواد الخام",
      },
      summary: {
          total_label: "الإجمالي",
          viewDetails_label: "عرض التفاصيل",
      },
      actions: {
          filter_label: "تصفية",
          refresh_label: "تحديث",
          clearAll_label: "مسح الكل",
      },
  },
  
    crossHire: {
      title: 'التأجير المتبادل',
      request: {
        title: 'طلبات التأجير المتبادل',
        addLabel: 'إضافة جديد',
        editLabel: 'المعرف: :id',
        table: {
          id: 'المعرف',
          date: 'التاريخ',
          rentalOrderId: 'معرف طلب الإيجار',
          status: 'الحالة',
          item: 'العنصر',
          vendorName: 'اسم المورد',
          uom: 'وحدة القياس',
          description: 'الوصف',
          quantity: 'الكمية',
          rate: 'السعر',
          replacementCost: 'تكلفة الاستبدال',
          available: 'المتوفر',
          onHand: 'المخزون المتاح',
          rentalDurationType: 'نوع مدة الإيجار',
          discountItem: 'العنصر المخفض',
          discountRate: 'نسبة الخصم',
          grossAmount: 'المبلغ الإجمالي',
          taxAmount: 'قيمة الضريبة',
          discountAmount: 'قيمة الخصم',
          netAmount: 'المبلغ الصافي',
          totalAmount: 'المبلغ الإجمالي',
          taxTemplate: 'قالب الضريبة',
          taxRate: 'معدل الضريبة',
          location: 'الموقع',
          department: 'القسم',
          narration: 'السرد'
        },
        msg: {
          add: 'تمت إضافة الطلب بنجاح',
          update: 'تم تحديث الطلب معرف: :id بنجاح',
          delete: 'تم حذف الطلب معرف: :id بنجاح',
          requestSubmitted: 'تم تقديم الطلب معرف: :id للموافقة',
          requestApproved: 'تمت الموافقة على الطلب',
          requestRejected: 'تم رفض الطلب',
        },
        sections: {
          basicDetails: 'التفاصيل الأساسية',
          items: 'العناصر',
          classification: 'التصنيف',
          attachment: 'المرفقات'
        },
        fields: {
          id_label: 'المعرف',
          id_placeholder: 'أدخل المعرف',
          date_label: 'التاريخ',
          date_placeholder: 'حدد التاريخ',
          rentalOrderId_label: 'معرف طلب الإيجار',
          rentalOrderId_placeholder: 'أدخل معرف طلب الإيجار',
          company_label: 'الشركة',
          company_placeholder: 'حدد الشركة',
          purchaseRepresentative_label: 'ممثل الشراء',
          purchaseRepresentative_placeholder: 'حدد ممثل الشراء',
          vendor_label: 'المورد',
          vendor_placeholder: 'حدد المورد',
          currency_label: 'العملة',
          currency_placeholder: 'حدد العملة',
          narration_label: 'السرد',
          narration_placeholder: 'أدخل السرد',
          items_label: 'العناصر',
          item_label: 'العنصر',
          vendorItemName_label: 'اسم عنصر المورد',
          uom_label: 'وحدة القياس',
          classification_label: 'التصنيف',
          location_label: 'الموقع',
          location_placeholder: 'حدد الموقع',
          department_label: 'القسم',
          attachment_label: 'المرفقات',
          upload_label: 'تحميل'
        }
      }
    }
	},

  common: {
    summary: "الملخص",
    activity: "النشاط",
    add: "إضافة",
    edit: "تعديل",
    delete: "حذف",
    noData: "لا توجد بيانات",
    allAttributes_label: "جميع السمات",
    addCustomField_label: "إضافة حقل مخصص",
    addColumn_label: "إضافة عمود",
    sunday: "الأحد",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    open: "مفتوح",
    closed: "مغلق",
    start_time: "وقت البدء",
    end_time: "وقت الانتهاء",
    active: "نشط",
    inActive: "غير نشط",
    deleteMsg: "هل أنت متأكد أنك تريد الحذف",
    confirmMsg: "هل أنت متأكد أنك تريد",
    new: "جديد",
    submitForApproval: "إرسال للموافقة",
    quickApproval: "موافقة سريعة",
    duplicate: "تكرار",
    actions: "الإجراءات",
    submit: "إرسال",
    reSubmit: "إعادة الإرسال",
    accept: "قبول",
    reject: "رفض",
    release: "إصدار",
    scrap: "خردة",
    cancel: "إلغاء",
    close: "إغلاق",
    create: "إنشاء",
    view: "عرض",
    next: "التالي",
    logs: "السجلات",
    addLog: "إضافة سجل جديد",
    validate: "تحقق",
    buttons: {
      saveAsDraft_label: "حفظ كمسودة",
      discard_label: "تجاهل",
      save_label: "حفظ",
    },
    field: {
      narration: "التعليق",
      narration_placeholder: "أدخل التعليق",
    },
  },
};

export default ar_resource;
